module.exports = __webpack_public_path__ + "static/media/shopping-cart.51b97039.svg";